import { useState, useEffect, useCallback, useRef } from "react";
import { useAuth } from "../contexts/AuthContext";
import {
  getDonorPartnerships,
  getReceiverPartnerships,
} from "../api/partnershipsApi";

export const usePartnershipsData = () => {
  const { user } = useAuth();
  const [donorData, setDonorData] = useState([]);
  const [receiverData, setReceiverData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const isFetching = useRef(false);

  const isDonor = user?.can_donate || user?.is_master_admin || user?.is_company_admin;
  const isReceiver = user?.can_receive || user?.is_master_admin || user?.is_company_admin;

  const fetchAll = useCallback(async () => {
    if (isFetching.current) return;
    isFetching.current = true;
    setError(null);

    try {
      // fetch independently so one failure doesn't block the other
      if (isDonor) {
        try {
          const donorRes = await getDonorPartnerships();
          if (donorRes?.partnerships) setDonorData(donorRes.partnerships);
        } catch (err) {
          console.error("Error fetching donor partnerships:", err);
        }
      }

      if (isReceiver) {
        try {
          const receiverRes = await getReceiverPartnerships();
          if (receiverRes?.partnerships) setReceiverData(receiverRes.partnerships);
        } catch (err) {
          console.error("Error fetching receiver partnerships:", err);
        }
      }
    } catch (err) {
      console.error("Error fetching partnerships:", err);
      setError(err.message);
    } finally {
      setLoading(false);
      isFetching.current = false;
    }
  }, [isDonor, isReceiver]);

  useEffect(() => {
    if (user) fetchAll();
  }, [user, fetchAll]);

  return {
    donorData,
    receiverData,
    loading,
    error,
    refresh: fetchAll,
    isDonor,
    isReceiver,
  };
};
